import { useTranslation } from 'react-i18next'; // Import the translation function

import { ClinicCard } from '../components/ClinicCard';
import {
  clinicsWithMatchingCoordinatesSelector,
  sortedClinicsWithDistance,
} from '../store/selectors';
import { useLocatorStore } from '../store/useLocatorStore';
import { generateDistanceLabel } from '../utils/helpers';

const cardListClasses = ['clinic-book-appointment', 'clinic-directions', 'clinic-call'];

export function ClinicList() {
  const { t } = useTranslation(); // Use translation function here

  const {
    closestClinic,
    radius,
    radiusUnit,
    setActiveClinic,
    activeClinic,
    visibleClinics,
    listType,
  } = useLocatorStore((state) => state);

  const sortedClinics = useLocatorStore((state) =>
    sortedClinicsWithDistance(state, visibleClinics)
  );

  const radiusUnitTranslated = radiusUnit === 'km' ? t('km') : t('miles');
  const clinicsWithMatchingCoordinates = clinicsWithMatchingCoordinatesSelector(
    activeClinic,
    visibleClinics
  );

  return (
    <div>
      {closestClinic && (
        <div className="flex border-[#C2CFD1] border-b border-solid px-[48px] py-[48px] text-center text-[1em] font-medium">
          {t(`Sorry, there are no clinics within `)} {radius} {radiusUnitTranslated}{' '}
          {t(
            `but here is the nearest clinic. To explore other clinics, simply drag the map in the direction you want or perform a new search.`
          )}
        </div>
      )}

      {listType === 'map' && activeClinic && (
        <div className="md:tw-hidden md:px-[40px] ">
          {clinicsWithMatchingCoordinates.map((clinic) => {
            return (
              <ClinicCard
                clinic={clinic}
                key={clinic.API_Id__c}
                distance={generateDistanceLabel(
                  clinic.distanceInMetres!,
                  radiusUnit,
                  t('miles'),
                  t('km')
                )}
                className="border-b border-[#C2CFD1] border-solid pt-[20px] clinic-card"
              />
            );
          })}
        </div>
      )}

      {sortedClinics.map((clinic) => {
        return (
          <div
            key={clinic.Id}
            className={`md:block md:px-[40px] pt-[20px] ${listType === 'map' && 'tw-hidden'}`}
            style={{
              backgroundColor:
                activeClinic?.API_Id__c === clinic.API_Id__c ||
                clinicsWithMatchingCoordinates.find(
                  ({ API_Id__c }) => API_Id__c === clinic.API_Id__c
                )
                  ? 'rgba(217, 186, 71, 0.05)'
                  : 'inherit',
            }}
          >
            <ClinicCard
              clinic={clinic}
              id={clinic.API_Id__c}
              onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                setActiveClinic(clinic);
                let isInArray = false;

                if (e.target instanceof HTMLElement) {
                  const classCardArray = Array.from(e.target.classList);

                  isInArray = classCardArray.filter((value) => cardListClasses.includes(value))
                    .length
                    ? true
                    : false;
                }
                if (!isInArray) {
                  // @ts-expect-error
                  if (window.dataLayer) {
                    // @ts-expect-error
                    window.dataLayer.push({
                      'clinic_ID': clinic.Id,
                      'clinic_Name': clinic.Name,
                      'event': 'Clinic Card Click',
                    });
                  }
                }
              }}
              key={clinic.API_Id__c}
              distance={generateDistanceLabel(
                clinic.distanceInMetres!,
                radiusUnit,
                t('miles'),
                t('km')
              )}
              className="border-b border-solid border-[#C2CFD1] clinic-card"
            />
          </div>
        );
      })}
    </div>
  );
}
